import React, { useState, useEffect, Suspense } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar'

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import styles from '../../App.module.css'
import classes from './Cart.module.css'

// import noThumb from "../../images/no-thumb.jpg";

function Cart() {
    const [product, setProduct] = useState([]);
    const [progress, setProgress] = useState(10);

    console.log(product);

    const fetchData = () => {
      axios.get(`https://wesharez.com/api/viewproduct.php?pid=53`)
      .then(response => {
          setProduct(response.data);
          setProgress(100);
      })
    }

    useEffect(() => {
        fetchData();
    }, []);

  return (
    <>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <div className="products-component p-4">
                <div className="content ws-box p-15">
                    <h1 className={classes.cart_title}>Shopping Cart</h1>
                    <br />
                    <div className="table-responsive">
                        <table className="table cart-table bg-white mb-1">
                            <thead>
                                <tr>
                                    <td className="text-center rs-none">Image</td>
                                    <td className="text-left">Product Name</td>
                                    <td className="text-left rs-none">Model</td>
                                    <td className="text-left">Quantity</td>
                                    <td className="text-right rs-none">Unit Price</td>
                                    <td className="text-right">Total</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center rs-none">
                                        <a href="https://wesharez.com/product/view/49">
                                            <img className={classes.img_thumbnail} src="https://wesharez.com/storage/media/products/2cad9eb487a6b7dc7988c18e514f9531-52277.jpeg" alt="We're-Hair" title="We're-Hair" />
                                        </a>
                                    </td>
                                    <td className="text-left">
                                        <a className={classes.product_name} href="https://wesharez.com/product/view/49">We're-Hair</a>
                                    </td>
                                    <td className="text-left rs-none"></td>
                                    <td className="text-left">
                                        <div className={`input-group btn-block ` + classes.inputs}>
                                            <form className={classes.quantity_form} action="" method="POST">
                                                <input type="number" name="quantity" min="1" value="1" size="1" className="form-control" />
                                                <input type="hidden" name="id" value="89" />
                                                <button type="submit" value="1" className={classes.update_quantity}>
                                                    <i class="fa-solid fa-rotate"></i>
                                                </button>
                                            </form>
                                            <a className={classes.remove_item} data-id="" href="https://wesharez.com/cart?remove_item&amp;id=89">
                                                <i class="fa-solid fa-xmark"></i>
                                            </a>
                                        </div>
                                    </td>
                                    <td className="text-right rs-none">£14.99</td>
                                    <td className="text-right">£14.99</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className={classes.cart_total}>
                        <div className={classes.wrapper}>
                            <table className="table bg-white cart-total m-0">
                                <tbody>
                                <tr>
                                    <td className="text-right"><strong>Sub-Total:</strong></td>
                                    <td className="text-right amount">£14.99</td>
                                </tr>
                                <tr>
                                    <td className="text-right"><strong>Shipping Cost:</strong></td>
                                    <td className="text-right amount">free</td>
                                </tr>
                                <tr>
                                    <td className="text-right"><strong>Grand Total:</strong></td>
                                    <td className="text-right amount">£14.99</td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    <div className={classes.cart_buttons}>
                        <div className="pull-right">
                            <Link to="checkout" className={`btn btn-primary ${classes.checkout_btn}`}>Confirm Order</Link>
                        </div>
                        <div className="pull-right">
                            <Link to="/products" className={`btn btn-success ${classes.shopping_btn}`}>Continue Shopping</Link>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </Suspense>
      </div>
      </>
  )
}

export default Cart